import { Component } from '@angular/core';

@Component({
  selector: 'app-exit-impersonation-modal',
  templateUrl: './exit-impersonation-modal.component.html',
  styleUrls: ['./exit-impersonation-modal.component.scss'],
})
export class ExitImpersonationModalComponent {}
